/**
 * Staff Market access — Lab `profile.bookmakerSessionFlag`.
 *
 * Set on Access Level create/edit; sent on books / account-statement calls so
 * onlyBookmaker / onlySession / bookmakerSession staff only see allowed markets.
 */

export type BookmakerSessionFlag =
  | 'all'
  | 'onlyBookmaker'
  | 'onlySession'
  | 'bookmakerSession'

const FLAGS: BookmakerSessionFlag[] = [
  'all',
  'onlyBookmaker',
  'onlySession',
  'bookmakerSession',
]

export function resolveBookmakerSessionFlag(
  raw: string | null | undefined,
): BookmakerSessionFlag {
  const value = (raw ?? 'all').trim() as BookmakerSessionFlag
  return FLAGS.includes(value) ? value : 'all'
}

/**
 * Lab Market Types chip when the operator has not picked a narrower filter.
 * Used to client-filter Bet Ticker rows (CM ticker SQL has no marketType yet).
 */
export function tickerMarketTypeForFlag(
  flag: BookmakerSessionFlag,
): 'Bookmaker' | 'Fancy' | undefined {
  if (flag === 'onlyBookmaker') return 'Bookmaker'
  if (flag === 'onlySession') return 'Fancy'
  return undefined
}
